import SVG from "../SVG";
import TableAdmin from "../Table/TableAdmin";
import { TableLoadingState } from "../AsyncState";

export default function MultipleSelectAdmin({
  header,
  search = false,
  searchValue,
  setSearchState = () => {
    return;
  },
  searchClick = () => {
    return;
  },
  footer,
  footerValue,
  tableColumns,
  tableData,
  onRowClick,
  selectedIndex,
  onTableScroll,
  isLoadingMore = false,
}) {
  return (
    <div className="w-full flex flex-col gap-2.5">
      {/* header */}
      <div
        className={`w-full flex items-center ${search && "justify-between"}`}
      >
        <p className="text-sm font-normal text-zi-text-light/50 dark:text-zi-text-dark/50">
          {header}
        </p>
        {search && (
          <div className="relative w-40">
            <input
              value={searchValue}
              onChange={(e) => {
                setSearchState(e.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  searchClick();
                }
              }}
              placeholder="جستجو"
              className="w-full !justify-start !rounded-lg !py-1.5 pr-2.5 pl-10 text-zi-text-light/50 dark:text-zi-text-dark/50 bg-zi-bg1-light dark:bg-zi-bg1-dark"
            />
            <button
              type="button"
              onClick={searchClick}
              className="absolute inset-y-0 left-0 flex items-center pl-2.5 bg-transparent"
            >
              <SVG
                name="search"
                classname="size-5 stroke-zi-text-light/50 dark:stroke-zi-text-dark/50"
              />
            </button>
          </div>
        )}
      </div>
      {/* table */}
      <div className="rounded-lg border-zi-border-dark">
        <TableAdmin
          columns={tableColumns}
          data={tableData}
          onRowClick={onRowClick}
          selectedIndex={selectedIndex}
          onTableScroll={onTableScroll}
          bottomContent={
            isLoadingMore ? (
              <TableLoadingState more className="!py-3" />
            ) : null
          }
        />
      </div>
      {/* footer */}
      <div className="w-full flex items-center gap-2.5">
        <p className="text-sm font-normal text-zi-text-light/50 dark:text-zi-text-dark/50">
          {footer}
        </p>
        <p className="text-zi-text-light dark:text-zi-text-dark">
          {footerValue}
        </p>
      </div>
    </div>
  );
}
